import { Component } from "@angular/core";

@Component({
  selector: "lib-error-icon",
  template: `<i class="ph ph-exclamation-mark bg-red text-white text-xl rounded-full w-6 h-6 flex items-center justify-center"></i>`,
  styles: [':host { display: inline-block; }']
})
export class ErrorIconComponent {}
